import React, { useEffect } from "react";
import VersionControlComp from "../Components/VersionControl/VersionControlComp";
import VersionControl1 from "../Components/VersionControl/VersionControl";
const VersionControl = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <VersionControl1 />;
};

export default VersionControl;